import { useState, type FormEvent } from 'react'

export default function Login({ onSuccess }: { onSuccess: () => void }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const r = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      })
      if (!r.ok) {
        const data = await r.json().catch(() => ({})) as { error?: string }
        setError(data.error ?? 'Identifiants invalides')
        return
      }
      onSuccess()
    } catch {
      setError('Erreur réseau')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login">
      <form className="login-box" onSubmit={submit}>
        <h1>Map SITG</h1>
        <p>Accès restreint — connexion requise</p>
        <label htmlFor="u">Utilisateur</label>
        <input
          id="u"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          required
        />
        <label htmlFor="p">Mot de passe</label>
        <input
          id="p"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
        {error && <div className="login-error">{error}</div>}
      </form>
    </div>
  )
}
